"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenIconTextButton = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const koden_koden_add_icon_1 = require("@scott/koden.koden-add-icon");
const TopBar = styled_components_1.default.div `
	width: fit-content;
	display: flex;
	align-items: center;
	border: ${(prop) => prop.outlined ? `1px solid ${prop.borderColor}` : "none"};
	background-color: ${(prop) => prop.backgroundColor};
	border-radius: 25px;
	padding: 0 1rem;

	cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
	user-select: none;

	*:first-child {
		margin-right: 0.5rem;
	}
`;
const KodenIconTextButton = ({ className = "", text, onClick, outlined = false, backgroundColor = "transparent", borderColor = "#D9D9D9", textColor = "#000000", icon, disabled = false, }) => {
    const spanColor = disabled ? "#7E7E7E" : textColor;
    return (React.createElement(TopBar, { className: `top-bar ${className}`, outlined: outlined, backgroundColor: backgroundColor, borderColor: borderColor, disabled: disabled, onClick: () => {
            if (!disabled) {
                onClick();
            }
        } },
        icon || React.createElement(koden_koden_add_icon_1.KodenAddIcon, { disabled: disabled, className: "add-icon" }),
        React.createElement("span", { style: { color: spanColor } }, text)));
};
exports.KodenIconTextButton = KodenIconTextButton;
exports.default = exports.KodenIconTextButton;
//# sourceMappingURL=koden-icon-text-button.js.map